import { mrpV2ActionTypes } from '../../actions/production/mrpV2Actions';

const MrpV2Reducers = (state = {}, action) => {
  switch (action.type) {
  // mrp v2
  case mrpV2ActionTypes.CREATE_MRP_V2.LOADING: {
    const { createMrpV2Loading } = action;
    return {
      ...state,
      createMrpV2Loading,
    };
  }
  // get mrp v2
  case mrpV2ActionTypes.GET_MRP_V2.LOADING: {
    const { getMrpV2Loading } = action;
    return {
      ...state,
      getMrpV2Loading,
    };
  }
  case mrpV2ActionTypes.GET_MRP_V2.SUCCESS: {
    const { mrpV2 } = action;
    return {
      ...state,
      mrpV2,
    };
  }
  // Get Production Items
  case mrpV2ActionTypes.GET_PRODUCTION_ITEMS.LOADING: {
    const { getProductionItemsLoading } = action;
    return {
      ...state,
      getProductionItemsLoading,
    };
  }
  case mrpV2ActionTypes.GET_PRODUCTION_ITEMS.SUCCESS: {
    const { productionItems } = action;
    return {
      ...state,
      productionItems,
    };
  }
  // Get Stock Items
  case mrpV2ActionTypes.GET_STOCK_ITEMS.LOADING: {
    const { getStockItemsLoading, entityType } = action;
    if (entityType === 'SALES_ORDER') {
      return {
        ...state,
        getStockItemsSOLoading: getStockItemsLoading,
      };
    }
    if (entityType === 'RAW_MATERIAL') {
      return {
        ...state,
        getStockItemsRMLoading: getStockItemsLoading,
      };
    }
    if (entityType === 'SHORTAGE') {
      return {
        ...state,
        getStockItemsShortageLoading: getStockItemsLoading,
      };
    }

    return {
      ...state,
      getStockItemsLoading,
    };
  }
  case mrpV2ActionTypes.GET_STOCK_ITEMS.SUCCESS: {
    const { stockItems, entityType } = action;

    if (entityType === 'SALES_ORDER') {
      return {
        ...state,
        stockItemsSO: stockItems,
      };
    }
    if (entityType === 'RAW_MATERIAL') {
      return {
        ...state,
        stockItemsRM: stockItems,
      };
    }
    if (entityType === 'SHORTAGE') {
      return {
        ...state,
        stockItemsShortage: stockItems,
      };
    }
  }
  // link so to Mrp
  case mrpV2ActionTypes.LINK_SO_TO_MRP.LOADING: {
    const { LinkSoToMRPLoading } = action;
    return {
      ...state,
      LinkSoToMRPLoading,
    };
  }
  // Push To Production Items
  case mrpV2ActionTypes.PUSH_TO_PRODUCTION_ITEMS.LOADING: {
    const { pushToProductionItemsLoading } = action;
    return {
      ...state,
      pushToProductionItemsLoading,
    };
  }
  // Push To Stock Items
  case mrpV2ActionTypes.PUSH_TO_STOCK_ITEMS.LOADING: {
    const { pushToStockItemsLoading } = action;
    return {
      ...state,
      pushToStockItemsLoading,
    };
  }
  // update Mrp v2
  case mrpV2ActionTypes.UPDATE_MRP_V2.LOADING: {
    const { updateMrpV2Loading } = action;
    return {
      ...state,
      updateMrpV2Loading,
    };
  }
  // Update MRP Production
  case mrpV2ActionTypes.UPDATE_MRP_PRODUCTION.LOADING: {
    const { updateMrpProductionLoading } = action;
    return {
      ...state,
      updateMrpProductionLoading,
    };
  }
  // Get Linked MOs
  case mrpV2ActionTypes.GET_LINKED_MO.LOADING: {
    const { getLinkedMOLoading } = action;
    return {
      ...state,
      getLinkedMOLoading,
    };
  }
  case mrpV2ActionTypes.GET_LINKED_MO.SUCCESS: {
    const { linkedMO } = action;
    return {
      ...state,
      linkedMO,
    };
  }

  // update mrp Stock Items
  case mrpV2ActionTypes.UPDATE_MRP_STOCK_ITEMS.LOADING: {
    const { updateMrpStockItemsLoading } = action;
    return {
      ...state,
      updateMrpStockItemsLoading,
    };
  }

  // Link So to Mrp
  case mrpV2ActionTypes.LINK_MO_TO_MRP.LOADING: {
    const { linkMoToMrpLoading } = action;
    return {
      ...state,
      linkMoToMrpLoading,
    };
  }

  case mrpV2ActionTypes.LINK_PO_TO_MRP.LOADING: {
    const { linkPoToMrpLoading } = action;
    return {
      ...state,
      linkPoToMrpLoading,
    };
  }

  // unlink so to Mrp
  case mrpV2ActionTypes.UNLINK_SO_TO_MRP.LOADING: {
    const { unlinkSoToMrpLoading } = action;
    return {
      ...state,
      unlinkSoToMrpLoading,
    };
  }

  // unlink so to Mrp
  case mrpV2ActionTypes.UNLINK_PO_TO_MRP.LOADING: {
    const { unlinkPoToMrpLoading } = action;
    return {
      ...state,
      unlinkPoToMrpLoading,
    };
  }

  // Reserve Shortage
  case mrpV2ActionTypes.RESERVE_SHORTAGE.LOADING: {
    const { reserveShortageMrpLoading } = action;
    return {
      ...state,
      reserveShortageMrpLoading,
    };
  }

  // unlink mo to Mrp
  case mrpV2ActionTypes.UNLINK_MO_TO_MRP.LOADING: {
    const { unlinkMoToMrpLoading } = action;
    return {
      ...state,
      unlinkMoToMrpLoading,
    };
  }

  // close mrp plan
  case mrpV2ActionTypes.CLOSE_MRP_PLAN.LOADING: {
    const { closeMrpPlanLoading } = action;
    return {
      ...state,
      closeMrpPlanLoading,
    };
  }

  case mrpV2ActionTypes.GET_MRP_SUMMARY.LOADING: {
    const { getMrpSummaryLoading } = action;
    return {
      ...state,
      getMrpSummaryLoading,
    };
  }

  case mrpV2ActionTypes.GET_MRP_SUMMARY.SUCCESS: {
    const { mrpSummary } = action;
    return {
      ...state,
      mrpSummary,
    };
  }

  // Reserve Shortage
  case mrpV2ActionTypes.CLEAR_RESERVATION.LOADING: {
    const { clearReservationLoading } = action;
    return {
      ...state,
      clearReservationLoading,
    };
  }

  case mrpV2ActionTypes.DELETE_MRP_V2.LOADING: {
    const { deleteMrpV2Loading } = action;
    return {
      ...state,
      deleteMrpV2Loading,
    };
  }

  // link existing po to mrp
  case mrpV2ActionTypes.GET_LINK_EXISTING_PO_TO_MRP.LOADING: {
    const { getLinkExistingPoToMrpLoading } = action;
    return {
      ...state,
      getLinkExistingPoToMrpLoading,
    };
  }

  case mrpV2ActionTypes.GET_LINK_EXISTING_PO_TO_MRP.SUCCESS: {
    const { getLinkPoToMrp } = action;
    return {
      ...state,
      getLinkPoToMrp,
    };
  }

  case mrpV2ActionTypes.LINK_EXISTING_PO_TO_MRP.LOADING: {
    const { LinkExistingPoToMrpV2Loading } = action;
    return {
      ...state,
      LinkExistingPoToMrpV2Loading,
    };
  }

  case mrpV2ActionTypes.UNLINK_LINKED_PO_TO_MRP.LOADING: {
    const { unlinkLinkedPoToMrpLoading } = action;
    return {
      ...state,
      unlinkLinkedPoToMrpLoading,
    };
  }

  case mrpV2ActionTypes.UPDATE_LINKED_PO_TO_MRP.LOADING: {
    const { updateLinkedPoToMrpLoading } = action;
    return {
      ...state,
      updateLinkedPoToMrpLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default MrpV2Reducers;
